/**
 * Métadonnées légères des articles mis en avant sur la page d'accueil.
 *
 * Pourquoi ce fichier : la section « Conseils & inspirations » de l'accueil
 * n'affiche que 4 vignettes (image + titre + catégorie). Importer tout
 * `blogArticles` (~89 Ko, corps markdown complet des 19 articles) juste pour ça
 * chargeait ce poids sur CHAQUE visite de la home. On isole ici le strict
 * nécessaire ; le contenu complet ne se charge plus que sur /blog et /blog/:id
 * (pages désormais en lazy).
 *
 * ⚠️ Les `id` doivent correspondre à ceux de blogArticles.ts (les liens pointent
 * vers /blog/:id). Si tu changes une vignette, garde l'id synchronisé.
 */

export type FeaturedArticle = {
  id: string;
  title: string;
  category: string;
  image: string;
};

export const featuredArticles: FeaturedArticle[] = [
  {
    id: "videaste-immobilier-bordeaux",
    title: "Vidéaste immobilier à Bordeaux : vendez et louez plus vite grâce à la vidéo",
    category: "Immobilier",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1200&q=80",
  },
  {
    id: "drone-video-entreprise-bordeaux",
    title: "Drone vidéo entreprise : filmer votre société par les airs à Bordeaux",
    category: "Entreprises",
    image: "https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=1200&q=80",
  },
  {
    id: "choisir-videaste-drone-mariage-bordeaux",
    title: "Comment choisir son vidéaste drone pour un mariage à Bordeaux",
    category: "Mariages",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&q=80",
  },
  {
    id: "reglementation-drone-gironde-2025",
    title: "Réglementation drone en Gironde : tout ce qu'il faut savoir en 2025",
    category: "Conseils",
    image: "https://images.unsplash.com/photo-1508614589041-895b88991e3e?w=1200&q=80",
  },
];
